(() => {
  function initNavigation(root) {
    const button = root.querySelector('[data-menu-toggle]');
    const nav = root.querySelector('[data-mobile-nav]');
    if (!button || !nav || button.dataset.bound) return;
    button.dataset.bound = 'true';
    const close = () => { button.setAttribute('aria-expanded','false'); nav.hidden = true; };
    button.addEventListener('click', () => { const open = button.getAttribute('aria-expanded') === 'true'; button.setAttribute('aria-expanded',String(!open)); nav.hidden = open; });
    nav.addEventListener('click',e => { if (e.target.closest('a')) close(); });
    document.addEventListener('keydown',e => { if(e.key === 'Escape' && !nav.hidden) { close(); button.focus(); } });
    window.matchMedia('(min-width: 900px)').addEventListener('change',close);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>initNavigation(document),{once:true});
  else initNavigation(document);
  document.addEventListener('shopify:section:load',e=>initNavigation(e.target));
})();
(() => {
  function initProductImageSwaps(root = document) {
    root.querySelectorAll('.product-image-swap--multiple').forEach(container => {
      if (container.dataset.imageSwapBound) return;
      const secondary = container.querySelector('.product-image-swap__secondary');
      if (!secondary) return;
      container.dataset.imageSwapBound = 'true';
      const markReady = () => {
        if (secondary.naturalWidth > 0) container.classList.add('product-image-swap--ready');
      };
      secondary.addEventListener('load', markReady, { once: true });
      secondary.addEventListener('error', () => {
        container.classList.remove('product-image-swap--ready');
      }, { once: true });
      if (secondary.complete) markReady();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProductImageSwaps(), { once: true });
  } else {
    initProductImageSwaps();
  }
  document.addEventListener('shopify:section:load', event => initProductImageSwaps(event.target));
})();
